(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["planett-builder-v2"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('planett-pack-builder')) {
  customElements.define('planett-pack-builder', class extends HTMLElement {
    connectedCallback() {
      this.v = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.si = +this.dataset.size;
      this.ci = +this.dataset.colour;
      this.p = Math.min(...this.v.map((variant) => variant.price));
      this.creditThreshold = +this.dataset.creditThreshold || 10;
      this.creditRate = +this.dataset.creditRate || 5;
      this.brandingMinimum = +this.dataset.brandingMinimum || 10;
      this.embroideryVariant = +this.dataset.embroideryVariant || 0;
      this.printingVariant = +this.dataset.printingVariant || 0;
      this.embroideryPrice = +this.dataset.embroideryPrice || 900;
      this.printingPrice = +this.dataset.printingPrice || 800;
      this.brandingTierVariants = {
        10: {
          embroidery: +this.getAttribute('data-embroidery-variant-20') || this.embroideryVariant,
          printing: +this.getAttribute('data-printing-variant-20') || this.printingVariant
        },
        50: {
          embroidery: +this.getAttribute('data-embroidery-variant-50') || this.embroideryVariant,
          printing: +this.getAttribute('data-printing-variant-50') || this.printingVariant
        },
        100: {
          embroidery: +this.getAttribute('data-embroidery-variant-100') || this.embroideryVariant,
          printing: +this.getAttribute('data-printing-variant-100') || this.printingVariant
        }
      };
      this.lines = [];
      this.brandingMethod = '';
      this.brandingPositions = { embroidery: new Set(), printing: new Set() };
      this.artworkFiles = [];
      this.artworkError = '';
      this.artworkMaxFiles = +this.dataset.artworkMaxFiles || 5;
      this.artworkMaxBytes = (+this.dataset.artworkMaxSize || 20) * 1024 * 1024;
      this.bind();
      this.render();
      this.update();
    }

    money(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
        style: 'currency',
        currency: this.dataset.currency
      }).format(cents / 100);
    }

    escape(value) {
      const element = document.createElement('span');
      element.textContent = value;
      return element.innerHTML;
    }

    bind() {
      this.querySelectorAll('[data-colour-value]').forEach((row) => {
        row.querySelector('[data-colour-select]').onclick = () => this.toggleColour(row.dataset.colourValue);
      });

      this.querySelector('[data-add-option]').onclick = () => this.addOption();
      this.querySelector('[data-clear-options]').onclick = () => this.clearOptions();
      this.querySelector('[data-submit]').onclick = () => this.add();
      this.querySelectorAll('[data-branding-method]').forEach((button) => {
        button.onclick = () => this.setBrandingMethod(button.dataset.brandingMethod);
      });
      this.querySelectorAll('[data-position-type]').forEach((button) => {
        button.onclick = () => this.toggleBrandingPosition(button.dataset.positionType, button.dataset.position);
      });

      const artworkInput = this.querySelector('[data-artwork-input]');
      const artworkDrop = this.querySelector('[data-artwork-drop]');
      artworkInput.onchange = () => {
        this.addArtworkFiles([...artworkInput.files]);
        artworkInput.value = '';
      };
      artworkDrop.ondragover = (event) => {
        event.preventDefault();
        artworkDrop.classList.add('is-dragging');
      };
      artworkDrop.ondragleave = () => artworkDrop.classList.remove('is-dragging');
      artworkDrop.ondrop = (event) => {
        event.preventDefault();
        artworkDrop.classList.remove('is-dragging');
        this.addArtworkFiles([...event.dataTransfer.files]);
      };

      this.querySelectorAll('[data-zoom]').forEach((button) => {
        button.onclick = () => {
          const dialog = this.querySelector('[data-dialog]');
          const image = dialog.querySelector('img');
          image.src = button.dataset.zoom;
          image.alt = button.querySelector('img')?.alt || '';
          dialog.showModal();
        };
      });

      this.querySelectorAll('[data-colour-zoom]').forEach((button) => {
        button.onclick = () => {
          const dialog = this.querySelector('[data-dialog]');
          const image = dialog.querySelector('img');
          image.src = button.dataset.colourZoom;
          image.alt = button.querySelector('img')?.alt || '';
          dialog.showModal();
        };
      });

      this.querySelectorAll('[data-size-chart-zoom]').forEach((button) => {
        button.onclick = () => {
          const dialog = this.querySelector('[data-dialog]');
          const image = dialog.querySelector('img');
          image.src = button.dataset.sizeChartZoom;
          image.alt = button.dataset.sizeChartAlt || '';
          dialog.showModal();
        };
      });

      this.querySelector('[data-close]').onclick = () => this.querySelector('[data-dialog]').close();
    }

    needsArtwork() {
      const quantity = this.lines.reduce((sum, line) => sum + line.quantity, 0);
      return quantity >= this.brandingMinimum &&
        (this.brandingMethod === 'embroidery' || this.brandingMethod === 'printing' || this.brandingMethod === 'both');
    }

    addArtworkFiles(files) {
      const accepted = /\.(ai|eps|pdf|svg|png|jpe?g)$/i;
      this.artworkError = '';
      for (const file of files) {
        if (this.artworkFiles.length >= this.artworkMaxFiles) {
          this.artworkError = 'You can upload up to ' + this.artworkMaxFiles + ' files.';
          break;
        }
        if (!accepted.test(file.name)) {
          this.artworkError = file.name + ' is not an accepted artwork file.';
          continue;
        }
        if (file.size > this.artworkMaxBytes) {
          this.artworkError = file.name + ' is larger than ' + Math.round(this.artworkMaxBytes / 1024 / 1024) + 'MB.';
          continue;
        }
        const duplicate = this.artworkFiles.some((item) =>
          item.name === file.name && item.size === file.size && item.lastModified === file.lastModified
        );
        if (!duplicate) this.artworkFiles.push(file);
      }
      this.renderArtwork();
      this.update();
    }

    removeArtworkFile(index) {
      this.artworkFiles.splice(index, 1);
      this.artworkError = '';
      this.renderArtwork();
      this.update();
    }

    formatFileSize(bytes) {
      if (bytes < 1024 * 1024) return Math.max(1, Math.round(bytes / 1024)) + 'KB';
      return (bytes / 1024 / 1024).toFixed(1) + 'MB';
    }

    renderArtwork() {
      const list = this.querySelector('[data-artwork-list]');
      const status = this.querySelector('[data-artwork-status]');
      list.innerHTML = this.artworkFiles.map((file, index) =>
        '<li><span><strong>' + this.escape(file.name) + '</strong> — ' + this.formatFileSize(file.size) + '</span>' +
        '<button type="button" data-remove-artwork="' + index + '" aria-label="Remove ' + this.escape(file.name) + '">Remove</button></li>'
      ).join('');
      list.querySelectorAll('[data-remove-artwork]').forEach((button) => {
        button.onclick = () => this.removeArtworkFile(+button.dataset.removeArtwork);
      });
      status.classList.toggle('is-error', Boolean(this.artworkError));
      status.textContent = this.artworkError ||
        (this.artworkFiles.length
          ? this.artworkFiles.length + (this.artworkFiles.length === 1 ? ' artwork file attached.' : ' artwork files attached.')
          : 'Upload at least one logo or design file to continue.');
    }

    setBrandingMethod(method) {
      this.brandingMethod = method;
      if (method !== 'embroidery' && method !== 'both') this.brandingPositions.embroidery.clear();
      if (method !== 'printing' && method !== 'both') this.brandingPositions.printing.clear();
      this.updateBranding();
      this.update();
    }

    toggleBrandingPosition(type, position) {
      const positions = this.brandingPositions[type];
      if (!positions) return;
      if (positions.has(position)) positions.delete(position);
      else positions.add(position);
      this.updateBranding();
      this.update();
    }

    resetBranding() {
      this.brandingMethod = '';
      this.brandingPositions.embroidery.clear();
      this.brandingPositions.printing.clear();
      this.artworkFiles = [];
      this.artworkError = '';
      this.updateBranding();
    }

    brandingLabel() {
      return {
        plain: 'Garment only',
        embroidery: 'Embroidery',
        printing: 'Printing',
        both: 'Embroidery and printing'
      }[this.brandingMethod] || '';
    }

    brandingValid() {
      const quantity = this.lines.reduce((sum, line) => sum + line.quantity, 0);
      if (quantity < this.brandingMinimum) return true;
      if (!this.brandingMethod) return false;
      if (this.brandingMethod === 'plain') return true;
      const needsEmbroidery = this.brandingMethod === 'embroidery' || this.brandingMethod === 'both';
      const needsPrinting = this.brandingMethod === 'printing' || this.brandingMethod === 'both';
      return (!needsEmbroidery || this.brandingPositions.embroidery.size > 0) &&
        (!needsPrinting || this.brandingPositions.printing.size > 0) &&
        this.artworkFiles.length > 0;
    }

    brandingProperties() {
      const quantity = this.lines.reduce((sum, line) => sum + line.quantity, 0);
      const properties = {
        'Branding Method': quantity < this.brandingMinimum ? 'Garment only' : this.brandingLabel()
      };
      if (this.brandingPositions.embroidery.size) {
        properties['Embroidery Positions'] = [...this.brandingPositions.embroidery].join(', ');
      }
      if (this.brandingPositions.printing.size) {
        properties['Printing Positions'] = [...this.brandingPositions.printing].join(', ');
      }
      if (this.artworkFiles.length) {
        properties['_PLANETT artwork files'] = this.artworkFiles.map((file) => file.name).join(', ');
      }
      properties['Branding Applies To'] = 'All items in this order';
      return properties;
    }

    brandingPricing(quantity) {
      const tier = this.tierFor(Math.max(1, quantity));
      const variants = this.brandingTierVariants[tier.threshold] || {};
      return {
        discount: tier.discount,
        embroideryPrice: Math.round(this.embroideryPrice * (100 - tier.discount) / 100),
        printingPrice: Math.round(this.printingPrice * (100 - tier.discount) / 100),
        embroideryVariant: variants.embroidery || this.embroideryVariant,
        printingVariant: variants.printing || this.printingVariant
      };
    }

    brandingRegularCharge() {
      const quantity = this.lines.reduce((sum, line) => sum + line.quantity, 0);
      if (quantity < this.brandingMinimum || this.brandingMethod === 'plain') return 0;
      return quantity * (
        this.brandingPositions.embroidery.size * this.embroideryPrice +
        this.brandingPositions.printing.size * this.printingPrice
      );
    }

    brandingCharge() {
      const quantity = this.lines.reduce((sum, line) => sum + line.quantity, 0);
      if (quantity < this.brandingMinimum || this.brandingMethod === 'plain') return 0;
      const pricing = this.brandingPricing(quantity);
      return quantity * (
        this.brandingPositions.embroidery.size * pricing.embroideryPrice +
        this.brandingPositions.printing.size * pricing.printingPrice
      );
    }

    brandingChargeItems(quantity) {
      const charges = [];
      const pricing = this.brandingPricing(quantity);
      const embroideryQuantity = quantity * this.brandingPositions.embroidery.size;
      const printingQuantity = quantity * this.brandingPositions.printing.size;

      if (embroideryQuantity && pricing.embroideryVariant) {
        charges.push({
          id: pricing.embroideryVariant,
          quantity: embroideryQuantity,
          properties: {
            'Branding service': 'Embroidery',
            'Positions': [...this.brandingPositions.embroidery].join(', '),
            '_PLANETT applies to': quantity + ' garments'
          }
        });
      }

      if (printingQuantity && pricing.printingVariant) {
        charges.push({
          id: pricing.printingVariant,
          quantity: printingQuantity,
          properties: {
            'Branding service': 'Printing',
            'Positions': [...this.brandingPositions.printing].join(', '),
            '_PLANETT applies to': quantity + ' garments'
          }
        });
      }

      return charges;
    }

    updateBranding() {
      const quantity = this.lines.reduce((sum, line) => sum + line.quantity, 0);
      const canSelectBranding = quantity >= this.brandingMinimum;
      const pricing = this.brandingPricing(Math.max(quantity, this.brandingMinimum));
      this.querySelector('[data-embroidery-rate]').textContent = this.money(pricing.embroideryPrice) + ' per garment / position';
      this.querySelector('[data-printing-rate]').textContent = this.money(pricing.printingPrice) + ' per garment / position';
      const brandingStep = this.querySelector('[data-branding-step]');
      const positionStep = this.querySelector('[data-position-step]');

      if (!canSelectBranding) {
        this.brandingMethod = '';
        this.brandingPositions.embroidery.clear();
        this.brandingPositions.printing.clear();
      }

      const needsEmbroidery = this.brandingMethod === 'embroidery' || this.brandingMethod === 'both';
      const needsPrinting = this.brandingMethod === 'printing' || this.brandingMethod === 'both';
      const decorated = needsEmbroidery || needsPrinting;

      brandingStep.hidden = !canSelectBranding;
      positionStep.hidden = !canSelectBranding || !decorated;
      this.querySelector('[data-artwork-step]').hidden = !canSelectBranding || !decorated;

      this.querySelectorAll('[data-branding-method]').forEach((button) => {
        const selected = button.dataset.brandingMethod === this.brandingMethod;
        button.classList.toggle('active', selected);
        button.setAttribute('aria-pressed', selected);
      });

      this.querySelector('[data-embroidery-panel]').hidden = !needsEmbroidery;
      this.querySelector('[data-printing-panel]').hidden = !needsPrinting;

      this.querySelectorAll('[data-position-type]').forEach((button) => {
        const selected = this.brandingPositions[button.dataset.positionType].has(button.dataset.position);
        button.classList.toggle('active', selected);
        button.setAttribute('aria-pressed', selected);
      });

      const selection = this.querySelector('[data-branding-selection]');
      selection.textContent = this.brandingMethod
        ? this.brandingLabel() + ' selected.'
        : 'Select one option to continue.';

      const help = this.querySelector('[data-branding-help]');
      const missing = [];
      if (needsEmbroidery && !this.brandingPositions.embroidery.size) missing.push('an embroidery position');
      if (needsPrinting && !this.brandingPositions.printing.size) missing.push('a printing position');
      help.textContent = missing.length ? 'Select ' + missing.join(' and ') + ' to continue.' : '';

      const summary = this.querySelector('[data-branding-summary]');
      summary.hidden = !decorated || !this.brandingValid();
      this.querySelector('[data-summary-method]').textContent = this.brandingLabel();
      this.querySelector('[data-summary-embroidery-row]').hidden = !needsEmbroidery;
      this.querySelector('[data-summary-printing-row]').hidden = !needsPrinting;
      this.querySelector('[data-summary-embroidery]').textContent = [...this.brandingPositions.embroidery].join(', ');
      this.querySelector('[data-summary-printing]').textContent = [...this.brandingPositions.printing].join(', ');
      this.querySelector('[data-summary-branding-total]').textContent = this.money(this.brandingCharge());
      this.renderArtwork();
    }

    sizes() {
      if (this.si < 0) return ['One size'];
      return [...new Set(this.v.map((variant) => variant.options[this.si]).filter(Boolean))];
    }

    colours() {
      if (this.ci < 0) return [''];
      return [...this.querySelectorAll('[data-colour-value]')].map((item) => item.dataset.colourValue);
    }

    toggleColour(colour) {
      const index = this.lines.findIndex((line) => line.base && line.sourceColour === colour);
      if (index >= 0) {
        this.lines.splice(index, 1);
        if (!this.lines.some((line) => line.base)) {
          this.lines = [];
          this.resetBranding();
        }
      } else {
        this.lines.push({
          sourceColour: colour,
          base: true,
          size: this.sizes()[0] || '',
          colour,
          quantity: 0
        });
      }
      this.render();
      this.update();
      if (index < 0) {
        requestAnimationFrame(() => {
          const step = this.querySelector('[data-custom-step]');
          if (!step.hidden) {
            step.scrollIntoView({
              behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
              block: 'start'
            });
          }
        });
      }
    }

    addOption() {
      const selected = this.lines.find((line) => line.base);
      if (!selected || this.lines.length >= 100) return;
      this.lines.push({
        sourceColour: '',
        base: false,
        size: selected.size || this.sizes()[0] || '',
        colour: selected.colour || this.colours()[0] || '',
        quantity: 0
      });
      this.render();
      this.update();
    }

    clearOptions() {
      this.lines = [];
      this.resetBranding();
      this.querySelector('[data-status]').textContent = '';
      this.querySelector('[data-add-more]').hidden = true;
      this.render();
      this.update();
    }

    render() {
      this.querySelectorAll('[data-colour-value]').forEach((row) => {
        const selected = this.lines.some((line) => line.base && line.sourceColour === row.dataset.colourValue);
        const button = row.querySelector('[data-colour-select]');
        button.classList.toggle('active', selected);
        button.setAttribute('aria-pressed', selected);
        button.querySelector('span').textContent = selected ? 'Selected' : 'Select';
      });

      const step = this.querySelector('[data-custom-step]');
      const box = this.querySelector('[data-custom-rows]');
      step.hidden = this.lines.length < 1;
      this.updateBranding();

      if (!this.lines.length) {
        box.innerHTML = '';
        return;
      }

      const sizes = this.sizes();
      const colours = this.colours();
      let html = '<div class="ptb__custom-head" aria-hidden="true"><span>Select Size</span><span>Select Colour</span><span>Add Quantity</span></div>';

      this.lines.forEach((line, index) => {
        const sizeOptions = sizes.map((size) =>
          '<option value="' + this.escape(size) + '"' + (size === line.size ? ' selected' : '') + '>' + this.escape(size) + '</option>'
        ).join('');
        const colourOptions = colours.map((colour) =>
          '<option value="' + this.escape(colour) + '"' + (colour === line.colour ? ' selected' : '') + '>' + this.escape(colour || 'Default') + '</option>'
        ).join('');

        html += '<div class="ptb__custom-row" data-line="' + index + '">' +
          '<select data-row-size aria-label="Select Size">' + sizeOptions + '</select>' +
          '<select data-row-colour aria-label="Select Colour">' + colourOptions + '</select>' +
          '<div class="ptb__row-quantity"><button type="button" data-row-minus aria-label="Remove quantity">−</button><output aria-label="Quantity">' + line.quantity + '</output><button type="button" data-row-plus aria-label="Add quantity">+</button></div>' +
          '</div>';
      });

      box.innerHTML = html;
      box.querySelectorAll('[data-line]').forEach((row) => {
        const line = this.lines[+row.dataset.line];
        row.querySelector('[data-row-size]').onchange = (event) => {
          line.size = event.target.value;
          this.update();
        };
        row.querySelector('[data-row-colour]').onchange = (event) => {
          line.colour = event.target.value;
          this.update();
        };
        row.querySelector('[data-row-minus]').onclick = () => {
          line.quantity = Math.max(0, line.quantity - 1);
          this.render();
          this.update();
        };
        row.querySelector('[data-row-plus]').onclick = () => {
          const total = this.lines.reduce((sum, item) => sum + item.quantity, 0);
          if (total >= 999) return;
          line.quantity += 1;
          this.render();
          this.update();
        };
      });
    }

    variant(size, colour) {
      return this.v.find((variant) =>
        (this.si < 0 || variant.options[this.si] === size) &&
        (this.ci < 0 || variant.options[this.ci] === colour) &&
        variant.available
      );
    }

    items() {
      const items = new Map();

      this.lines.forEach((line) => {
        if (!line.quantity) return;
        const variant = this.variant(line.size, line.colour);
        if (variant) items.set(variant.id, (items.get(variant.id) || 0) + line.quantity);
        else items.set('bad', 1);
      });

      return items;
    }

    tiers() {
      return [...this.querySelectorAll('[data-tier]')]
        .map((tier) => ({
          element: tier,
          threshold: +tier.dataset.threshold,
          discount: +tier.dataset.discount
        }))
        .sort((a, b) => a.threshold - b.threshold);
    }

    tierFor(quantity) {
      return this.tiers().reduce((selected, tier) => quantity >= tier.threshold ? tier : selected, this.tiers()[0]);
    }

    update() {
      const items = this.items();
      const quantity = this.lines.reduce((sum, line) => sum + line.quantity, 0);
      const tier = this.tierFor(Math.max(1, quantity));
      const unitPrice = Math.round(this.p * (100 - tier.discount) / 100);
      const totalPrice = unitPrice * quantity;
      const regularTotal = this.p * quantity;
      const brandingCharge = this.brandingCharge();
      const brandingRegularCharge = this.brandingRegularCharge();
      const finalTotal = totalPrice + brandingCharge;
      const finalRegularTotal = regularTotal + brandingRegularCharge;
      const totalSaving = finalRegularTotal - finalTotal;

      this.querySelector('[data-total]').textContent = this.money(finalTotal);
      this.querySelector('[data-buy-total]').textContent = this.money(finalTotal);
      this.querySelector('[data-unit]').textContent = this.money(unitPrice) + (brandingCharge ? ' apparel / item' : ' / item');

      const compareTotal = this.querySelector('[data-compare-total]');
      const totalSavingLabel = this.querySelector('[data-total-saving]');
      compareTotal.hidden = totalSaving < 1;
      totalSavingLabel.hidden = totalSaving < 1;
      compareTotal.textContent = this.money(finalRegularTotal);
      totalSavingLabel.textContent = 'YOU SAVE ' + this.money(totalSaving);

      const brandingChargeLabel = this.querySelector('[data-branding-charge]');
      brandingChargeLabel.hidden = brandingCharge < 1;
      brandingChargeLabel.textContent = brandingCharge
        ? 'Branding: ' + this.money(brandingCharge) + ' (' + quantity + ' garments × selected positions)'
        : '';

      const saving = this.querySelector('[data-save]');
      saving.hidden = tier.discount < 1;
      saving.textContent = tier.discount ? 'Save ' + tier.discount + '%' : '';

      const tiers = this.tiers().sort((a, b) => a.threshold - b.threshold);
      tiers.forEach((priceTier) => {
        priceTier.element.classList.toggle('active', priceTier.threshold === tier.threshold);
        priceTier.element.querySelector('[data-tier-price]').textContent =
          this.money(Math.round(this.p * (100 - priceTier.discount) / 100)) + ' / item';
      });

      const offer = this.querySelector('[data-offer]');
      const progress = this.querySelector('[data-offer-progress]');
      const offerHeading = this.querySelector('[data-offer-heading]');
      const offerMessage = this.querySelector('[data-offer-message]');
      const remainingToCredit = Math.max(0, this.creditThreshold - quantity);
      const progressValue = Math.min(quantity, this.creditThreshold);
      const creditValue = quantity >= this.creditThreshold
        ? Math.round(finalTotal * this.creditRate / 100)
        : 0;
      if (offer && progress) {
        offer.classList.toggle('unlocked', quantity >= this.creditThreshold);
        progress.setAttribute('aria-valuenow', progressValue);
        progress.querySelector('span').style.width = (progressValue / this.creditThreshold * 100) + '%';
        if (quantity >= this.creditThreshold) {
          offerHeading.textContent = 'UNLOCKED — ' + this.creditRate + '% PLANETT STORE CREDIT';
          offerMessage.textContent = 'You’ll earn ' + this.money(creditValue) + ' in PLANETT Store Credit to use on your next order.';
        } else if (quantity > 0) {
          offerHeading.textContent = 'ONLY ' + remainingToCredit + ' MORE ' + (remainingToCredit === 1 ? 'ITEM' : 'ITEMS') + ' TO UNLOCK';
          offerMessage.textContent = 'Reach 10 items to unlock 5% off apparel and branding, plus earn 5% back as PLANETT Store Credit.';
        } else {
          offerHeading.textContent = 'ORDER 10+ & EARN 5% BACK';
          offerMessage.textContent = 'Save 5% on apparel and branding, then earn 5% of this order back as PLANETT Store Credit.';
        }
      }

      const nextTier = quantity < this.creditThreshold
        ? tiers.find((priceTier) => priceTier.threshold === this.creditThreshold)
        : tiers.find((priceTier) => priceTier.threshold > quantity);
      const nextTierMessage = this.querySelector('[data-next-tier]');
      if (nextTier) {
        const remaining = nextTier.threshold - quantity;
        nextTierMessage.textContent = quantity < this.creditThreshold
          ? 'Add ' + remaining + ' more ' + (remaining === 1 ? 'item' : 'items') + ' to unlock ' + nextTier.discount + '% off and ' + this.creditRate + '% PLANETT Store Credit.'
          : 'Add ' + remaining + ' more ' + (remaining === 1 ? 'item' : 'items') + ' to unlock ' + nextTier.discount + '% off.';
      } else {
        nextTierMessage.textContent = quantity >= 100 ? 'Best advertised discount unlocked. Contact us for further 100+ pricing.' : '';
      }

      this.querySelector('[data-submit]').disabled = items.has('bad') || quantity < 1 || !this.brandingValid();
    }

    async add() {
      const items = this.items();
      const button = this.querySelector('[data-submit]');
      const status = this.querySelector('[data-status]');
      const addMore = this.querySelector('[data-add-more]');
      addMore.hidden = true;

      if (items.has('bad')) {
        status.textContent = 'Choose an available combination.';
        return;
      }

      if (this.needsArtwork() && !this.artworkFiles.length) {
        status.textContent = 'Upload at least one logo or design file before adding to cart.';
        this.querySelector('[data-artwork-step]').scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
        return;
      }

      if (!this.brandingValid()) {
        status.textContent = 'Select a branding method and the required position(s).';
        return;
      }

      const quantity = [...items.values()].reduce((sum, value) => sum + value, 0);
      const tier = this.tierFor(quantity);
      const brandingProperties = this.brandingProperties();
      const lineItems = [...items].map(([id, itemQuantity]) => ({
        id: +id,
        quantity: itemQuantity,
        properties: Object.assign({
          '_PLANETT quantity': quantity + ' items',
          '_PLANETT volume tier': tier.discount + '%',
          '_PLANETT store credit offer': quantity >= this.creditThreshold ? this.creditRate + '% Redeemly credit' : 'Not qualified'
        }, brandingProperties)
      }));
      lineItems.push(...this.brandingChargeItems(quantity));
      if (this.artworkFiles.length) {
        lineItems.forEach((item, index) => {
          item.properties['_PLANETT artwork reference'] = index === 0
            ? this.artworkFiles.length + ' file(s) attached'
            : 'See artwork attached to first garment line';
        });
      }

      button.disabled = true;
      status.textContent = 'Adding…';

      try {
        let request;
        if (this.artworkFiles.length) {
          const formData = new FormData();
          lineItems.forEach((item, index) => {
            formData.append('items[' + index + '][id]', item.id);
            formData.append('items[' + index + '][quantity]', item.quantity);
            Object.entries(item.properties).forEach(([name, value]) => {
              formData.append('items[' + index + '][properties][' + name + ']', value);
            });
          });
          this.artworkFiles.forEach((file, index) => {
            formData.append('items[0][properties][Artwork ' + (index + 1) + ']', file, file.name);
          });
          request = {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: formData
          };
        } else {
          request = {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ items: lineItems })
          };
        }
        const response = await fetch(this.dataset.add, request);
        const data = await response.json();
        if (!response.ok) throw Error(data.description || 'Unable to add this selection.');
        status.innerHTML = 'Added to your cart.' + (quantity >= this.creditThreshold ? ' This order qualifies for ' + this.creditRate + '% PLANETT Store Credit.' : '') + ' <a href="' + this.dataset.cart + '">VIEW CART</a>';
        addMore.hidden = false;
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      } catch (error) {
        status.textContent = error.message;
      } finally {
        button.disabled = false;
        this.update();
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["planett-clothing"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('planett-colour-size')) {
    customElements.define('planett-colour-size', class extends HTMLElement {
      connectedCallback() {
        this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
        this.selection = {};
        this.colourPosition = Number(this.dataset.colourPosition);
        this.sizePosition = Number(this.dataset.sizePosition);
        this.form = this.querySelector('form');
        this.submit = this.querySelector('[data-submit]');
        this.status = this.querySelector('[data-status]');
        this.hero = this.querySelector('.pcs__hero-image');
        this.hero.removeAttribute('width');
        this.hero.removeAttribute('height');
        this.quantity = this.querySelector('[data-quantity]');
        this.quantityMinus = this.querySelector('[data-quantity-minus]');
        this.offer = this.querySelector('[data-offer]');
        this.offerText = this.querySelector('[data-offer-text]');
        this.offerProgress = this.querySelector('[data-offer-progress]');
        this.currentVariant = null;
        this.isInitialising = true;
        this.querySelectorAll('[data-option-value]').forEach((button) => button.addEventListener('click', () => this.select(button)));
        this.querySelectorAll('[data-gallery-image]').forEach((button) => button.addEventListener('click', () => this.showGalleryImage(button)));
        this.quantityMinus.addEventListener('click', () => this.changeQuantity(-1));
        this.querySelector('[data-quantity-plus]').addEventListener('click', () => this.changeQuantity(1));
        this.quantity.addEventListener('change', () => this.setQuantity(this.quantity.value));
        this.quantity.addEventListener('blur', () => this.setQuantity(this.quantity.value));
        const sizeChartOpen = this.querySelector('[data-size-chart-open]');
        if (sizeChartOpen) sizeChartOpen.addEventListener('click', () => this.querySelector('[data-size-chart-dialog]').showModal());
        const sizeChartClose = this.querySelector('[data-size-chart-close]');
        if (sizeChartClose) sizeChartClose.addEventListener('click', () => this.querySelector('[data-size-chart-dialog]').close());
        this.querySelectorAll('dialog').forEach((dialog) => dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        }));
        this.form.addEventListener('submit', (event) => this.add(event), true);
        this.appObserver = new MutationObserver(() => this.suppressProductOptions());
        this.appObserver.observe(this.form, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
        this.suppressProductOptions();
        this.setQuantity(1);
        this.refreshAvailability();
        const optionGroups = Array.from(this.querySelectorAll('[data-option-group]'));
        optionGroups.forEach((group) => {
          const availableOptions = Array.from(group.querySelectorAll('[data-option-value]')).filter((button) => !button.disabled);
          if (availableOptions.length === 1) this.select(availableOptions[0]);
        });
        if (optionGroups.length === 0 || optionGroups.every((group) => this.selection[Number(group.dataset.position)])) this.updateVariant();
        this.isInitialising = false;
      }

      disconnectedCallback() {
        if (this.appObserver) this.appObserver.disconnect();
      }

      suppressProductOptions() {
        this.form.querySelectorAll('.bss-po-product-page').forEach((panel) => panel.remove());
        if (this.currentVariant && this.currentVariant.available && this.submit.disabled) this.submit.disabled = false;
      }

      select(button) {
        const group = button.closest('[data-option-group]');
        const position = Number(group.dataset.position);
        this.selection[position] = button.dataset.optionValue;
        group.querySelectorAll('[data-option-value]').forEach((choice) => {
          const selected = choice === button;
          choice.classList.toggle('is-selected', selected);
          choice.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        const label = position === this.colourPosition ? this.querySelector('[data-colour-name]') : this.querySelector('[data-size-name]');
        if (label) label.textContent = button.dataset.optionValue;
        if (position === this.colourPosition) {
          if (!this.isInitialising && button.dataset.colourImage) this.setHero(button.dataset.colourImage, button.dataset.optionValue);
          const selectedSize = this.selection[this.sizePosition];
          const sizeStillAvailable = !selectedSize || this.variants.some((variant) => variant.available && variant.options[this.colourPosition - 1] === button.dataset.optionValue && variant.options[this.sizePosition - 1] === selectedSize);
          if (!sizeStillAvailable) {
            delete this.selection[this.sizePosition];
            const sizeGroup = this.querySelector('[data-option-group][data-position="' + this.sizePosition + '"]');
            sizeGroup.querySelectorAll('[data-option-value]').forEach((choice) => {
              choice.classList.remove('is-selected');
              choice.setAttribute('aria-pressed', 'false');
            });
            this.querySelector('[data-size-name]').textContent = this.dataset.requiredLabel;
          }
        }
        this.refreshAvailability();
        this.updateVariant();
      }

      refreshAvailability() {
        this.querySelectorAll('[data-option-group]').forEach((group) => {
          const position = Number(group.dataset.position);
          group.querySelectorAll('[data-option-value]').forEach((button) => {
            const value = button.dataset.optionValue;
            const available = this.variants.some((variant) => {
              if (!variant.available || variant.options[position - 1] !== value) return false;
              return Object.entries(this.selection).every(([selectedPosition, selectedValue]) => {
                return Number(selectedPosition) === position || variant.options[Number(selectedPosition) - 1] === selectedValue;
              });
            });
            button.disabled = !available;
          });
        });
      }

      updateVariant() {
        const groups = Array.from(this.querySelectorAll('[data-option-group]'));
        const ready = groups.every((group) => this.selection[Number(group.dataset.position)]);
        const variant = ready
          ? this.variants.find((item) => groups.every((group) => {
              const position = Number(group.dataset.position);
              return item.options[position - 1] === this.selection[position];
            }) && item.available) || this.variants.find((item) => groups.every((group) => {
              const position = Number(group.dataset.position);
              return item.options[position - 1] === this.selection[position];
            }))
          : null;
        this.currentVariant = variant || null;
        if (!variant) {
          this.submit.disabled = true;
          this.status.textContent = ready ? this.dataset.unavailable : this.dataset.choose;
          return;
        }
        this.querySelector('[data-variant-id]').value = variant.id;
        this.querySelector('[data-price]').textContent = this.money(variant.price);
        const compare = this.querySelector('[data-compare]');
        compare.hidden = !(variant.compare_at_price > variant.price);
        compare.textContent = compare.hidden ? '' : this.money(variant.compare_at_price);
        this.submit.disabled = !variant.available;
        this.status.textContent = variant.available ? '' : this.dataset.unavailable;
        this.suppressProductOptions();
        this.updateOffer();
        if (!this.isInitialising && variant.featured_image && variant.featured_image.src) this.setHero(variant.featured_image.src, variant.name || '');
      }

      money(cents) {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-AU', { style: 'currency', currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'AUD' }).format(cents / 100);
      }

      setHero(src, alt) {
        if (!this.hero || !src) return;
        this.hero.src = src;
        this.hero.srcset = '';
        this.hero.alt = alt;
        this.hero.removeAttribute('width');
        this.hero.removeAttribute('height');
      }

      showGalleryImage(button) {
        this.setHero(button.dataset.galleryImage, button.dataset.galleryAlt);
        this.querySelectorAll('[data-gallery-image]').forEach((thumb) => thumb.classList.toggle('is-active', thumb === button));
      }

      setQuantity(value) {
        const quantity = Math.max(1, Math.floor(Number(value) || 1));
        this.quantity.value = quantity;
        this.quantityMinus.disabled = quantity <= 1;
        this.updateOffer();
        return quantity;
      }

      changeQuantity(change) {
        this.setQuantity(this.setQuantity(this.quantity.value) + change);
      }

      updateOffer() {
        if (!this.offer || !this.offerText || !this.offerProgress) return;
        const threshold = Number(this.offer.dataset.threshold);
        const rate = Number(this.offer.dataset.rate);
        const subtotal = this.currentVariant ? this.currentVariant.price * Math.max(1, Math.floor(Number(this.quantity.value) || 1)) : 0;
        const progress = threshold > 0 ? Math.min(100, Math.round((subtotal / threshold) * 100)) : 0;
        this.offerProgress.setAttribute('aria-valuenow', progress);
        this.offerProgress.querySelector('span').style.width = progress + '%';
        if (!this.currentVariant) {
          this.offerText.textContent = this.offer.dataset.defaultText;
        } else if (subtotal >= threshold) {
          this.offerText.textContent = this.offer.dataset.earnedText.replace('[amount]', this.money(Math.round(subtotal * rate)));
        } else {
          this.offerText.textContent = this.offer.dataset.underText.replace('[amount]', this.money(threshold - subtotal));
        }
      }

      async add(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.submit.disabled) return;
        this.submit.disabled = true;
        this.status.textContent = this.submit.dataset.adding;
        try {
          const response = await fetch(this.dataset.cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(this.querySelector('[data-variant-id]').value), quantity: this.setQuantity(this.quantity.value) }] })
          });
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || 'Unable to add this item.');
          this.status.innerHTML = this.submit.dataset.added + ' <a href="' + this.dataset.cartUrl + '">' + this.submit.dataset.viewCart + '</a>';
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        } catch (error) {
          this.status.textContent = error.message;
        } finally {
          this.submit.disabled = false;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["planett-product-builder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('planett-pack-builder')) {
  customElements.define('planett-pack-builder', class extends HTMLElement {
    connectedCallback() {
      this.v = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.si = +this.dataset.size;
      this.ci = +this.dataset.colour;
      this.p = Math.min(...this.v.map((variant) => variant.price));
      this.c = {};
      this.bind();
      this.reset();
      this.render();
      this.update();
    }

    money(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
        style: 'currency',
        currency: this.dataset.currency
      }).format(cents / 100);
    }

    bind() {
      this.querySelectorAll('[data-size-value]').forEach((button) => {
        button.onclick = () => {
          this.querySelectorAll('[data-size-value]').forEach((item) => {
            item.classList.toggle('active', item === button);
            item.setAttribute('aria-pressed', item === button);
          });
          this.update();
        };
      });

      this.querySelectorAll('[data-colour-value]').forEach((row) => {
        row.querySelector('[data-minus]').onclick = () => this.change(row.dataset.colourValue, -1);
        row.querySelector('[data-plus]').onclick = () => this.change(row.dataset.colourValue, 1);
      });

      this.querySelector('[data-custom-toggle]').onchange = (event) => {
        this.querySelector('[data-colour-list]').hidden = event.target.checked;
        this.querySelector('[data-custom-rows]').hidden = !event.target.checked;
        this.render();
        this.update();
      };

      this.querySelector('[data-submit]').onclick = () => this.add();

      this.querySelectorAll('[data-zoom]').forEach((button) => {
        button.onclick = () => {
          const dialog = this.querySelector('[data-dialog]');
          const image = dialog.querySelector('img');
          image.src = button.dataset.zoom;
          image.alt = button.querySelector('img')?.alt || '';
          dialog.showModal();
        };
      });

      this.querySelectorAll('[data-colour-zoom]').forEach((button) => {
        button.onclick = () => {
          const dialog = this.querySelector('[data-dialog]');
          const image = dialog.querySelector('img');
          image.src = button.dataset.colourZoom;
          image.alt = button.querySelector('img')?.alt || '';
          dialog.showModal();
        };
      });

      this.querySelectorAll('[data-size-chart-zoom]').forEach((button) => {
        button.onclick = () => {
          const dialog = this.querySelector('[data-dialog]');
          const image = dialog.querySelector('img');
          image.src = button.dataset.sizeChartZoom;
          image.alt = button.dataset.sizeChartAlt || '';
          dialog.showModal();
        };
      });

      this.querySelector('[data-close]').onclick = () => this.querySelector('[data-dialog]').close();
    }

    sizes() {
      return [...this.querySelectorAll('[data-size-value]')].map((item) => item.dataset.sizeValue);
    }

    colours() {
      return [...this.querySelectorAll('[data-colour-value]')].map((item) => item.dataset.colourValue);
    }

    size() {
      return this.querySelector('[data-size-value].active')?.dataset.sizeValue || this.sizes()[0] || '';
    }

    reset() {
      this.c = {};
    }

    change(colour, amount) {
      const current = this.c[colour] || 0;
      const total = Object.values(this.c).reduce((sum, quantity) => sum + quantity, 0);
      if (amount < 0 && current < 1) return;
      if (amount > 0 && total >= 999) return;
      this.c[colour] = current + amount;
      this.update();
    }

    render() {
      const box = this.querySelector('[data-custom-rows]');
      if (!this.querySelector('[data-custom-toggle]').checked) {
        box.innerHTML = '';
        return;
      }

      const sizes = this.sizes();
      const colours = this.colours();
      const quantity = Math.max(1, Object.values(this.c).reduce((sum, value) => sum + value, 0));
      let html = '';

      for (let index = 0; index < quantity; index += 1) {
        html += '<div class="ptb__custom-row"><strong>' + (index + 1) + '</strong>';
        if (this.si >= 0) {
          html += '<select data-row-size aria-label="Size ' + (index + 1) + '">' + sizes.map((size) => '<option>' + size + '</option>').join('') + '</select>';
        }
        if (this.ci >= 0) {
          html += '<select data-row-colour aria-label="Colour ' + (index + 1) + '">' + colours.map((colour) => '<option>' + colour + '</option>').join('') + '</select>';
        }
        html += '</div>';
      }

      box.innerHTML = html;
      box.querySelectorAll('select').forEach((select) => {
        select.onchange = () => this.update();
      });
    }

    variant(size, colour) {
      return this.v.find((variant) =>
        (this.si < 0 || variant.options[this.si] === size) &&
        (this.ci < 0 || variant.options[this.ci] === colour) &&
        variant.available
      );
    }

    items() {
      const items = new Map();

      if (this.querySelector('[data-custom-toggle]').checked) {
        this.querySelectorAll('.ptb__custom-row').forEach((row) => {
          const variant = this.variant(
            row.querySelector('[data-row-size]')?.value || '',
            row.querySelector('[data-row-colour]')?.value || ''
          );
          if (variant) items.set(variant.id, (items.get(variant.id) || 0) + 1);
          else items.set('bad', 1);
        });
      } else {
        Object.entries(this.c).forEach(([colour, quantity]) => {
          if (!quantity) return;
          const variant = this.variant(this.size(), colour);
          if (variant) items.set(variant.id, (items.get(variant.id) || 0) + quantity);
          else items.set('bad', 1);
        });
      }

      return items;
    }

    tiers() {
      return [...this.querySelectorAll('[data-tier]')]
        .map((tier) => ({
          element: tier,
          threshold: +tier.dataset.threshold,
          discount: +tier.dataset.discount
        }))
        .sort((a, b) => a.threshold - b.threshold);
    }

    tierFor(quantity) {
      return this.tiers().reduce((selected, tier) => quantity >= tier.threshold ? tier : selected, this.tiers()[0]);
    }

    update() {
      this.querySelectorAll('[data-colour-value]').forEach((row) => {
        row.querySelector('output').textContent = this.c[row.dataset.colourValue] || 0;
      });

      const custom = this.querySelector('[data-custom-toggle]').checked;
      const items = this.items();
      const quantity = custom
        ? this.querySelectorAll('.ptb__custom-row').length
        : Object.values(this.c).reduce((sum, value) => sum + value, 0);
      const tier = this.tierFor(Math.max(1, quantity));
      const unitPrice = Math.round(this.p * (100 - tier.discount) / 100);
      const totalPrice = unitPrice * quantity;
      const regularTotal = this.p * quantity;
      const totalSaving = regularTotal - totalPrice;

      this.querySelector('[data-total]').textContent = this.money(totalPrice);
      this.querySelector('[data-buy-total]').textContent = this.money(totalPrice);
      this.querySelector('[data-unit]').textContent = this.money(unitPrice) + ' / item';

      const compareTotal = this.querySelector('[data-compare-total]');
      const totalSavingLabel = this.querySelector('[data-total-saving]');
      compareTotal.hidden = totalSaving < 1;
      totalSavingLabel.hidden = totalSaving < 1;
      compareTotal.textContent = this.money(regularTotal);
      totalSavingLabel.textContent = 'YOU SAVE ' + this.money(totalSaving);

      const saving = this.querySelector('[data-save]');
      saving.hidden = tier.discount < 1;
      saving.textContent = tier.discount ? 'Save ' + tier.discount + '%' : '';

      this.tiers().forEach((priceTier) => {
        priceTier.element.classList.toggle('active', priceTier.threshold === tier.threshold);
        priceTier.element.querySelector('[data-tier-price]').textContent =
          this.money(Math.round(this.p * (100 - priceTier.discount) / 100)) + ' / item';
      });

      this.querySelector('[data-submit]').disabled = items.has('bad') || quantity < 1;
    }

    async add() {
      const items = this.items();
      const button = this.querySelector('[data-submit]');
      const status = this.querySelector('[data-status]');
      const addMore = this.querySelector('[data-add-more]');
      addMore.hidden = true;

      if (items.has('bad')) {
        status.textContent = 'Choose an available combination.';
        return;
      }

      const quantity = [...items.values()].reduce((sum, value) => sum + value, 0);
      const tier = this.tierFor(quantity);
      const lineItems = [...items].map(([id, itemQuantity]) => ({
        id: +id,
        quantity: itemQuantity,
        properties: {
          '_PLANETT quantity': quantity + ' items',
          '_PLANETT volume tier': tier.discount + '%'
        }
      }));

      button.disabled = true;
      status.textContent = 'Adding…';

      try {
        const response = await fetch(this.dataset.add, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: lineItems })
        });
        const data = await response.json();
        if (!response.ok) throw Error(data.description || 'Unable to add this selection.');
        status.innerHTML = 'Added to your cart. <a href="' + this.dataset.cart + '">VIEW CART</a>';
        addMore.hidden = false;
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      } catch (error) {
        status.textContent = error.message;
      } finally {
        button.disabled = false;
        this.update();
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
